const resource = {
    resource_identifier_in_use: 'O identificador da API {{indicator}} já está em uso',
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
